import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    uploads: [], // 👈 multiple processes
    /** One combined job for inspiration gallery bulk publish (ZIP processing per item) */
    bulkGalleryJob: null,
};

const uploadProgressSlice = createSlice({
    name: "uploadProgress",
    initialState,
    reducers: {
        startUpload(state, action) {
            const id = action.payload.id;
            const existing = state.uploads.find((x) => x.id === id);
            if (existing) {
                existing.currentFile = existing.currentFile || "In progress…";
                return;
            }
            state.uploads.push({
                id,
                percent: 0,
                currentFile: "Preparing...",
            });
        },
        updateProgress(state, action) {
            const u = state.uploads.find(
                (x) => x.id === action.payload.id
            );
            if (u) {
                u.percent = action.payload.percent;
                u.currentFile = action.payload.currentFile;
            }
        },
        finishUpload(state, action) {
            const u = state.uploads.find(
                (x) => x.id === action.payload.id
            );
            if (u) u.percent = 100;
        },
        removeUpload(state, action) {
            state.uploads = state.uploads.filter(
                (x) => x.id !== action.payload.id
            );
        },
        startBulkGalleryJob(state, action) {
            const total = action.payload?.total ?? 0;
            state.bulkGalleryJob = {
                total,
                completed: 0,
                currentIndex: 0,
                currentTitle: "",
                currentFile: "",
                currentPercent: 0,
            };
        },
        setBulkGalleryCurrentItem(state, action) {
            if (!state.bulkGalleryJob) return;
            state.bulkGalleryJob.currentIndex = action.payload.index ?? 0;
            state.bulkGalleryJob.currentTitle = action.payload.title ?? "";
            state.bulkGalleryJob.currentFile = "Preparing…";
            state.bulkGalleryJob.currentPercent = 0;
        },
        updateBulkGalleryZipProgress(state, action) {
            if (!state.bulkGalleryJob) return;
            if (typeof action.payload.percent === "number") {
                state.bulkGalleryJob.currentPercent = action.payload.percent;
            }
            if (action.payload.currentFile != null) {
                state.bulkGalleryJob.currentFile = action.payload.currentFile;
            }
        },
        completeBulkGalleryItem(state) {
            if (!state.bulkGalleryJob) return;
            state.bulkGalleryJob.completed += 1;
            state.bulkGalleryJob.currentPercent = 0;
            state.bulkGalleryJob.currentFile = "";
        },
        endBulkGalleryJob(state) {
            state.bulkGalleryJob = null;
        },
        restoreBulkGalleryJob(state, action) {
            const p = action.payload;
            if (!p || typeof p.total !== "number") return;
            state.bulkGalleryJob = {
                total: p.total,
                completed: Math.min(p.total, p.completed ?? 0),
                currentIndex: p.currentIndex ?? 0,
                currentTitle: p.currentTitle ?? "",
                currentFile: p.currentFile ?? "Reconnecting…",
                currentPercent: typeof p.currentPercent === "number" ? p.currentPercent : 0,
            };
        },
    },
});

export const {
    startUpload,
    updateProgress,
    finishUpload,
    removeUpload,
    startBulkGalleryJob,
    setBulkGalleryCurrentItem,
    updateBulkGalleryZipProgress,
    completeBulkGalleryItem,
    endBulkGalleryJob,
    restoreBulkGalleryJob,
} = uploadProgressSlice.actions;

export default uploadProgressSlice.reducer;
